<template>
  <div class="buyers-container d-flex flex-column flex-grow-1">
    <b-row class="flex-grow-1 d-flex h-100">
      <b-col
        :md="9"
        class="flex-grow-1 d-flex flex-column pb-4 buyer-list-col"
        :order="1"
        :order-md="0"
      >
        <div>
          <b-form class="buyer-search-form mb-3" @submit.prevent>
            <b-input-group size="lg">
              <b-input-group-prepend>
                <b-input-group-text class="bg-secondary text-white">
                  <b-icon-search class="search-icon" font-scale="0.8" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                :placeholder="$t('buyers.index.placeHolder')"
                v-model="filter"
                id="filterInput"
              />
              <a
                href="#"
                class="clear-link"
                @click.prevent="filter = ''"
                v-if="filter !== ''"
              >
                <b-icon-x class="clear-icon" />
              </a>
            </b-input-group>
          </b-form>
        </div>
        <drip-card class="flex-grow-1 buyer-list-card d-flex flex-column">
          <div class="buyer-filters mt-4">
            <b-form>
              <b-row class="filter-row">
                <b-col
                  class="filter-col"
                  v-for="status in $t('buyers.buyerFilters')"
                  :key="status.key"
                >
                  <label class="d-block filter-label">
                    <drip-card
                      class="filter-card"
                      :class="[
                        getBuyerStageCategory(status.key),
                        { checked: filters.indexOf(status.key) > -1 }
                      ]"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          class="filter-checkbox custom-control-inline"
                          v-model="filters"
                          :value="status.key"
                        />
                        <span class="display-label">{{ status.label }}</span>
                        <!-- <span class="display-label">{{ status }}</span> -->
                      </div>
                      <span class="display-count">
                        {{ counter(status.key) }}
                        <b-link class="only" @click="handleOnly(status.key)">{{
                          $t('invoices.index.only')
                        }}</b-link>
                      </span>
                    </drip-card>
                  </label>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <request-modal ref="request-modal" />
          <div class="drip-table-container buyer-table">
            <loader :height="300" v-if="loading" />
            <div
              class="table-display"
              v-else-if="filteredBuyers && filteredBuyers.length > 0"
            >
              <b-table
                :items="filteredBuyers"
                :fields="buyerFields"
                :tbody-tr-class="buyerRow"
                :filter="filter"
                class="drip-table table-borderless"
              >
                <template #cell(importer)="data">
                  <div>
                    <span
                      :class="
                        getBuyerStageCategory(data.item.new_portal_status)
                      "
                    ></span>
                    <router-link
                      :to="{
                        name: 'buyersSingle',
                        params: { id: data.item.id }
                      }"
                      >{{ data.value }}</router-link
                    >
                    <div class="status-reason" v-if="data.item.status_reason">
                      {{ data.item.status_reason }}
                    </div>
                  </div>
                </template>
                <template #cell(new_portal_status)="data">
                  <div>
                    <span
                      class="buyers-stage-dot"
                      :class="
                        getBuyerStageCategory(data.item.new_portal_status)
                      "
                    ></span>
                    {{
                      $t(
                        `buyers.index.status['${data.item.new_portal_status}']`
                      )
                    }}
                  </div>
                </template>
                <template #cell(product_based_limit)="data">{{
                  data.value | currency(null, null, 0)
                }}</template>
                <template #cell(invoices_value_total)="data">{{
                  data.value | currency(null, null, 0)
                }}</template>
                <template #cell(balance)="data">{{
                  data.value | currency(null, null, 0)
                }}</template>

                <template #cell(invoice_acknowledgement_required?)="data">
                  <span>{{
                    data.value
                      ? $t('buyers.index.acknowledgement.yes')
                      : $t('buyers.index.acknowledgement.no')
                  }}</span>
                </template>

                <template #cell(full_recourse_label?)="data">
                  <span>{{
                    data.value
                      ? $t('buyers.index.fullRecourse')
                      : $t('buyers.index.limitedRecourse')
                  }}</span>
                </template>

                <template #cell(action)="data">
                  <div>
                    <b-link
                      size="sm"
                      class="pb-0 px-2 text-uppercase show action"
                      variant="outline-secondary"
                      v-if="
                        isIndian() &&
                        !(
                          data.item.importer_status === 'Approved' &&
                          !data.item['invoice_acknowledgement_required?']
                        )
                      "
                      @click.prevent="freshdeskTicket(data)"
                    >
                      {{
                        $t(
                          `buyers.index.directTicket['${data.item.importer_status}'].Action`
                        )
                      }}
                    </b-link>
                    <span
                      :id="`disabled-wrapper-${data.item.id}`"
                      v-b-tooltip.hover
                      :title="
                        clientUnlocked(data.item) ||
                        ddpCheck ||
                        !checkPermissionForAddInvoice()
                          ? $t('invoices.esign.toolTip')
                          : ''
                      "
                    >
                      <b-button
                        :disabled="
                          clientUnlocked(data.item) ||
                          ddpCheck ||
                          !checkPermissionForAddInvoice()
                        "
                        size="sm"
                        class="py-1 px-2 text-uppercase show action add-invoice"
                        variant="outline-primary"
                        @click="navigateToInvoice(data.item.id)"
                      >
                        <small>{{ $t('dashboard.addInvoiceBtn') }}</small>
                      </b-button>
                    </span>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="pt-5" v-else>
              <h4 class="text-center">{{ $t('buyers.index.notFound') }}</h4>
            </div>
          </div>
        </drip-card>
      </b-col>
      <b-col
        :md="3"
        class="alerts-list-col d-flex flex-column-reverse d-md-block"
        :order="0"
        :order-md="1"
      >
        <div>
          <b-button
            v-if="hasPermission"
            variant="secondary"
            class="d-flex align-items-center justify-content-center w-100 mb-3 p-3"
            @click="createBuyer"
            :disabled="buyerBtnLoading"
          >
            <b-icon-arrow-repeat
              v-if="buyerBtnLoading"
              animation="spin"
              class="mr-2"
            />
            {{ $t('buyers.add.title') }}
          </b-button>
        </div>
        <buyer-list-alerts
          class="mb-3"
          @filter-invoices="setFiltersandRedirect"
          :customer-pending-tasks="pendingTasks"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BuyerListAlerts from '../../components/invoices/list/Alerts'
import DripCard from '../../components/drip/ui/Card'
import Loader from '../../components/common/Loader'
import RequestModal from '../../components/common/RequestModal'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import freshdeskService from '@/services/freshdesk'
import exportersService from '@/services/exporters'
import buyersService from '@/services/buyers'
import applicantService from '@/services/applicants'
import monitoringService from '@/services/monitoring'
import { isInvoiceUploadBlocked } from '@/utils/monitoringAccess'

export default {
  data() {
    return {
      exporter: {},
      loading: true,
      buyerBtnLoading: false,
      buyerId: '',
      buyers: {},
      filter: '',
      filters: [],
      pendingTasks: [],
      monitoringData: null
    }
  },

  computed: {
    filteredBuyers() {
      const buyers = Object.values(this.buyers).reduce(
        (acc, val) => acc.concat(val),
        []
      )
      if (this.filters.length > 0) {
        return buyers.filter((client) => {
          return this.filters
            .map((filter) => client.new_portal_status === filter)
            .includes(true)
        })
      } else {
        return buyers
      }
    },
    newInvoiceRedirect() {
      return isInvoiceUploadBlocked(this.monitoringData)
    },
    buyerFields() {
      let buyerFields = this.$t('buyers.index.buyerFields')
      if (this.$i18n.locale === 'en-IN') {
        buyerFields = buyerFields.filter(
          ({ label }) => label !== 'Recourse Type'
        )
      }
      return buyerFields
    },
    hasPermission() {
      return (
        this.$store.getters.hasPermission('esign') ||
        this.$store.getters.hasPermission('edit')
      )
    },
    ddpCheck() {
      return this.$store.getters.ddpCheck === 0
    }
  },
  methods: {
    counter(status) {
      if (Object.keys(this.buyers).length > 0) {
        return Object.values(this.buyers[status]).length
      } else {
        return 0
      }
    },
    handleOnly(value) {
      if (value) this.$mpTrack(`Clicked on buyers list filter - ${value} only`)
      this.filters = [value]
    },
    getBuyers() {
      const buyersSorted = {
        'Funding Available': [],
        Processing: [],
        'On Hold': [],
        Rejected: []
      }
      this.exporter.clients &&
        this.exporter.clients.forEach((client) => {
          const status = client.new_portal_status
          buyersSorted[status].push(client)
        })
      this.buyers = buyersSorted
    },
    getBuyerStageCategory(buyerStatus) {
      if (!buyerStatus) {
        return ''
      }
      return buyerStatus.toLowerCase().split(' ').join('-')
    },
    showIncreaseRequest(buyer) {
      return (
        parseFloat(buyer.balance) / parseFloat(buyer.product_based_limit) > 0.8
      )
    },
    increaseLimitRequest(buyerId) {
      return this.$refs['request-modal'].show(() => {
        return applicantService.addApplicant({
          applicant: {
            buyerId: buyerId,
            accountId: this.$store.state.account.accountId,
            request: 'Increase Buyer Limit',
            channel: 'increase-limit-request'
          }
        })
      })
    },
    loadData() {
      return exportersService
        .fetchExporterMetaData(this.$store.state.account.accountId, {
          include: ['clients', 'bank_details']
        })
        .then((res) => {
          this.exporter = res.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    createBuyer() {
      this.buyerBtnLoading = true
      return buyersService
        .addBuyers({
          client: {
            exporter_user_id: this.$store.state.account.accountId
          }
        })
        .then((res) => {
          this.buyerBtnLoading = false
          return this.$router.push({
            name: 'buyersAdd',
            params: {
              buyerId: res.data.id
            }
          })
        })
        .catch(() => {
          this.buyerBtnLoading = false
        })
    },
    loadPendingTasks() {
      return exportersService
        .fetchExporterMetaData(this.$store.state.account.accountId, {
          include: ['customer_pending_task_flows']
        })
        .then((res) => {
          this.pendingTasks = res.data.customer_pending_task_flows
        })
        .catch(console.error)
    },
    setFiltersandRedirect(newFilters) {
      this.$router.push({
        name: 'invoices',
        params: { alertFilters: newFilters }
      })
    },
    freshdeskTicket(data) {
      const action = this.$t(
        `buyers.index.directTicket['${data.item.importer_status}'].Action`
      )
      this.$mpTrack(`Clicked on ${action} CTA`)
      return this.$refs['request-modal'].show(() => {
        return freshdeskService.createTicket(
          data,
          this.$t(
            `buyers.index.directTicket['${data.item.importer_status}'].questionType`
          ),
          this.$t(
            `buyers.index.directTicket['${data.item.importer_status}'].question`
          )
        )
      })
    },
    portalStatus(status) {
      return status === 'Funding Available' ? 'Fundable' : status
    },
    buyerRow(item, type) {
      if (!item || type !== 'row') return
      if (item.new_portal_status === 'Processing') return 'row-processing'
      else if (item.new_portal_status === 'Funding Available')
        return 'row-fundable'
      else if (item.new_portal_status === 'On Hold') return 'row-hold'
      else if (item.new_portal_status === 'Rejected') return 'row-rejected'
    },
    clientUnlocked(el) {
      return !el['locked?']
    },
    navigateToInvoice(id) {
      if (this.newInvoiceRedirect) {
        this.$mpTrack('Buyers - Redirect to account', {
          revoke_date: this.monitoringData.revoke_date
        })
        this.$router.push({ name: 'account' })
      } else {
        this.$mpTrack('Buyers - redirect to add invoice page')
        this.$router.push({ name: 'invoicesAdd', query: { buyerId: id } })
      }
    },
    checkPermissionForAddInvoice() {
      /**
       * ?: below is the old code for checking invoice add permission
       * return this.$store.getters.hasPermission('edit')
       */
      return this.$store.getters.hasInvoiceAddAndCreatePermission()
    },
    isIndian() {
      return this.$store.state.account.country === 'India'
    },
    async fetchMonitoringData() {
      this.loading = true
      try {
        const res = await monitoringService.getMonitoringData(
          this.$store.getters.accountId
        )
        this.monitoringData = res.data
      } catch (error) {
        console.error('Error fetching monitoring data:', error)
        // Optionally set an error message to display to the user
        this.errorMessage = 'Failed to fetch monitoring data. Please try again.'
      } finally {
        this.loading = false // Ensure loading is set to false regardless of success or error
      }
    }
  },
  mounted() {
    document.title = this.$t('buyers.index.htmlTitle')
    this.$mpTrack('Buyers page mounted')
    this.fetchMonitoringData()
    this.loadData()
    if (this.$store.state.account.country === 'India') {
      this.showAndPrefillFreshdesk({ cf_category_i: 'Buyer related' })
    }
    if (this.$store.state.account.accountId) {
      this.loadPendingTasks()
    }
  },
  watch: {
    filters(newValue, oldValue) {
      const filter = newValue && newValue.filter((x) => !oldValue.includes(x))
      if (filter[0])
        this.$mpTrack(`Clicked on buyers list filter - ${filter[0]}`)
    },
    exporter() {
      this.getBuyers()
    }
  },
  components: {
    BuyerListAlerts,
    DripCard,
    Loader,
    RequestModal
  },
  mixins: [freshdeskMixin]
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.buyers-container {
  align-self: stretch;
}
.buyer-list-col {
  height: 100%;
}
.buyer-search-form {
  position: relative;
  .form-control {
    height: 3.6rem !important;
    font-size: 1rem;
    &:focus {
      outline: 0;
      box-shadow: none;
      border-color: $gray-400;
    }
  }
  .input-group-text {
    width: 54px;
    text-align: center;
  }
  .search-icon {
    margin: auto;
  }
}
.clear-link {
  position: absolute;
  cursor: pointer;
  right: 0;
  height: 100%;
  width: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  z-index: 3;
  .clear-icon {
    width: 1.6rem;
    height: 1.6rem;
  }
}
.buyer-list-card {
  height: 80vh;
  & > .card-body {
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
.buyer-filters {
  .filter-row.row {
    margin-right: -5px;
    margin-left: -5px;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    & > .col {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  .filter-col {
    flex: 1;
  }
  .filter-label {
    cursor: pointer;
  }
  .filter-card.card {
    position: relative;
    overflow: hidden;
    .display-label {
      text-transform: uppercase;
      font-size: 11px;
      letter-spacing: 1.1px;
      width: max-content;
    }
    &.checked {
      .display-label,
      .display-count {
        font-weight: 600;
      }
    }
    .card-body {
      padding-top: 14px;
      padding-bottom: 12px;
      &:before {
        content: '';
        width: 5px;
        height: 100%;
        background: red;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    &.funding-available {
      .card-body {
        &:before {
          background: $approved-color;
        }
      }
    }
    &.processing {
      .card-body {
        &:before {
          background: $processing-color;
        }
      }
    }
    &.on-hold {
      .card-body {
        &:before {
          background: $pending-color;
        }
      }
    }
    &.rejected {
      .card-body {
        &:before {
          background: $advanced-color;
        }
      }
    }

    .only {
      visibility: hidden;
      font-size: 12px;
      font-weight: bold;
    }

    &:hover {
      .only {
        visibility: visible;
      }
    }
  }
}
.alerts-list-col {
  max-height: 100%;
}

.display-count {
  display: block;
  color: black;
  clear: left;
  font-size: 18px;
  font-family: $montserrat;
  &:before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 10.5px;
    border-radius: 100%;
    margin-bottom: 2px;
  }
  .filter-card.processing & {
    &:before {
      background: $processing-color;
    }
  }
  .filter-card.funding-available & {
    &:before {
      background: $approved-color;
    }
  }
  .filter-card.rejected & {
    &:before {
      background: $advanced-color;
    }
  }
  .filter-card.on-hold & {
    &:before {
      background: $pending-color;
    }
  }
}

.filter-checkbox.custom-control-inline {
  margin-right: 0;
  .custom-control-label {
    &:before,
    &:after {
      width: 15px;
      height: 15px;
    }
    &:before {
      background-color: transparent;
      border: 1px solid $dc-svg;
      border-radius: 1px;
      opacity: 0.3;
    }
  }
  .custom-control-input:checked ~ .custom-control-label {
    &:before {
      border: 0;
      opacity: 1;
      .filter-card.on-hold & {
        background-color: $pending-color;
      }
      .filter-card.processing & {
        background-color: $processing-color;
      }
      .filter-card.funding-available & {
        background-color: $approved-color;
      }
      .filter-card.rejected & {
        background-color: $advanced-color;
      }
    }
  }
}
@include media-breakpoint-down(sm) {
  .buyer-filters {
    .filter-row.row {
      overflow-x: scroll;
      .filter-card {
        .card-body {
          min-width: 9rem;
          .only {
            visibility: visible;
          }
        }
      }
    }
  }
}
.buyers-stage-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 8px;
  &.processing {
    background: $processing-color;
  }
  &.on-hold {
    background: $pending-color;
  }
  &.rejected {
    background: $advanced-color;
  }
  &.funding-available {
    background: $approved-color;
  }
}
@include media-breakpoint-down(sm) {
  .buyer-filters {
    .filter-row.row {
      overflow-x: scroll;
      .filter-card {
        .card-body {
          min-width: 9rem;
          .only {
            visibility: visible;
          }
        }
      }
    }
  }
}
.buyer-table {
  td.cell-border {
    width: 20%;
    position: relative;
    padding-left: 1rem;
    &:before {
      content: '';
      width: 5px;
      height: 100%;
      background: $advanced-color;
      position: absolute;
      left: 0;
      top: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .status-reason {
      color: $advanced-color;
    }
  }
  .row-processing {
    td.cell-border {
      &:before {
        background: $processing-color;
      }
      .status-reason {
        color: $processing-color;
      }
    }
  }
  .row-fundable {
    td.cell-border {
      &:before {
        background: $approved-color;
      }
      .status-reason {
        color: $approved-color;
      }
    }
  }
  .row-hold {
    td.cell-border {
      &:before {
        background: $pending-color;
      }
      .status-reason {
        color: $pending-color;
      }
    }
  }
  .no-wrap {
    white-space: nowrap;
    text-align: right;
  }
  .action {
    margin-left: 0.5rem;
  }
  tr:hover {
    .hovered {
      .hide {
        visibility: hidden;
      }
      .show {
        visibility: initial;
      }
    }
  }
}
</style>
